import React, { useState, useCallback } from 'react'
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import styles from './ModuleData.module.css'
import { Tabs, Tab } from 'react-bootstrap';
import ModuleRecords from './ModuleRecords';
import ModuleSingleRecord from './ModuleSingleRecord';
const ModuleData = ({ onSelectConv, OnAddToDialListClicked, newRecord }) => {
    const [activeTab, setActiveTab] = useState('all')
    const [t] = useTranslation('crm')

    const crmState = useSelector(state => state.crm)
    const { crmPath } = crmState

    let showBody = undefined
    if (crmPath?.value) {
        showBody = <ModuleSingleRecord onSelectConv={onSelectConv} OnAddToDialListClicked={OnAddToDialListClicked} />
    }
    else {
        showBody = <ModuleRecords onSelectConv={onSelectConv} OnAddToDialListClicked={OnAddToDialListClicked} newRecord={newRecord} />
    }

    return (showBody)
}
export default ModuleData